"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyModalStyleLink = exports.SankeyModalStyleNode = void 0;
/* eslint @typescript-eslint/no-var-requires: "off" */
const react_1 = __importStar(require("react"));
const fa_1 = require("react-icons/fa");
const react_2 = require("@chakra-ui/react");
const SankeyUtils_1 = require("../configmenus/SankeyUtils");
const SankeyMenuConfigurationNodesAttributes_1 = require("../configmenus/SankeyMenuConfigurationNodesAttributes");
const SankeyMenuConfigurationLinksAppearence_1 = require("../configmenus/SankeyMenuConfigurationLinksAppearence");
const SankeyMenuTop_1 = require("../topmenus/SankeyMenuTop");
const SankeyModalStyleNode = (applicationContext, dict_variable_application_data, dict_hook_ref_setter_show_dialog_components, ref_selected_style_node, ComponentUpdater, node_function, pointer_pos, node_attribute_tab) => {
    const { t } = applicationContext;
    const { data } = dict_variable_application_data;
    const { updateComponentMenuConfigNodeAppearence } = ComponentUpdater;
    const { RedrawNodes } = node_function;
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    const [selected_style_node, set_selected_style_node] = (0, react_1.useState)('default');
    ref_selected_style_node.current = selected_style_node;
    if (data.style_node && !Object.keys(data.style_node).includes(selected_style_node)) {
        set_selected_style_node('default');
    }
    const ref_input_name = (0, react_1.useRef)(null);
    const content = react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_grid' },
        react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menustylepanel_row_droplist' },
            react_1.default.createElement(react_2.Button, { variant: 'menuconfigpanel_add_button', onClick: () => {
                    const new_style = (0, SankeyUtils_1.DefaultNodeStyle)();
                    new_style.name = 'New Style';
                    const new_id = 'style_node_' + String(new Date().getTime());
                    new_style.idNode = new_id;
                    data.style_node[new_id] = new_style;
                    updateComponentMenuConfigNodeAppearence.current();
                    ref_selected_style_node.current = new_style.idNode;
                    set_selected_style_node(new_style.idNode);
                    setForceUpdate(!forceUpdate);
                    ref_input_name.current.value = data.style_node[new_id].name;
                } },
                react_1.default.createElement(fa_1.FaPlus, null)),
            react_1.default.createElement(react_2.Menu, null,
                react_1.default.createElement(react_2.MenuButton, { as: react_2.Button, variant: 'menuconfigpanel_option_button', rightIcon: react_1.default.createElement(fa_1.FaChevronDown, null) }, (selected_style_node !== '') ?
                    (0, SankeyUtils_1.CutName)(data.style_node[selected_style_node].name, 30) :
                    'Choix Style'),
                react_1.default.createElement(react_2.MenuList, null, Object
                    .keys(data.style_node)
                    .map((d, i) => {
                    return (react_1.default.createElement(react_2.MenuItem, { key: i, onClick: () => {
                            ref_selected_style_node.current = d;
                            set_selected_style_node(d);
                            ref_input_name.current.value = data.style_node[d].name;
                            setForceUpdate(!forceUpdate);
                        } }, data.style_node[d].name));
                }))),
            react_1.default.createElement(react_2.Button, { variant: 'menuconfigpanel_del_button', isDisabled: (selected_style_node === 'default'), onClick: () => {
                    Object.values(data.nodes).filter(n => n.style == selected_style_node).forEach(n => n.style = 'default');
                    delete data.style_node[selected_style_node];
                    const new_style = (Object.keys(data.style_node).length > 0) ? Object.keys(data.style_node)[0] : '';
                    set_selected_style_node(new_style);
                    ref_selected_style_node.current = new_style;
                    updateComponentMenuConfigNodeAppearence.current();
                    RedrawNodes(Object.values(dict_variable_application_data.display_nodes));
                    ComponentUpdater.updateComponenSaveInCache.current(false);
                    setForceUpdate(!forceUpdate);
                } },
                react_1.default.createElement(fa_1.FaMinus, null))),
        react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfigpanel_row_2cols', gridTemplateColumns: '1fr 7fr' },
            react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_option_name', textStyle: 'h3' }, t('Menu.ns')),
            react_1.default.createElement(react_2.Box, null,
                react_1.default.createElement(react_2.InputGroup, { variant: 'menuconfigpanel_option_input' },
                    react_1.default.createElement(react_2.Input, { variant: 'menuconfigpanel_option_input', disabled: (selected_style_node === 'default') ? true : false, ref: ref_input_name, defaultValue: data.style_node[selected_style_node].name, onBlur: () => {
                            var _a, _b;
                            data.style_node[selected_style_node].name = (_b = (_a = ref_input_name.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
                            setForceUpdate(!forceUpdate);
                            updateComponentMenuConfigNodeAppearence.current();
                            ComponentUpdater.updateComponenSaveInCache.current(false);
                        } })))),
        (0, SankeyMenuConfigurationNodesAttributes_1.SankeyWrapperConfigInModalOrMenu)(node_attribute_tab, true)[0]);
    return (0, SankeyMenuTop_1.MenuDraggable)(dict_hook_ref_setter_show_dialog_components, 'ref_setter_show_style_node', content, pointer_pos, t('Menu.esn'));
};
exports.SankeyModalStyleNode = SankeyModalStyleNode;
//Modal et fonctions pour l'edition et affectation des style de flux
const SankeyModalStyleLink = (applicationContext, dict_variable_application_data, dict_variable_elements_selected, dict_hook_ref_setter_show_dialog_components, pointer_pos, additional_link_appearence_items, link_function, ComponentUpdater) => {
    const { data } = dict_variable_application_data;
    const { t } = applicationContext;
    const { ref_selected_style_link } = dict_variable_elements_selected;
    const { updateComponentMenuConfigLink } = ComponentUpdater;
    const [selected_style_link, set_selected_style_link] = (0, react_1.useState)('default');
    const [forceUpdate, setForceUpdate] = (0, react_1.useState)(false);
    const ref_input_name = (0, react_1.useRef)(null);
    ref_selected_style_link.current = selected_style_link;
    if (data.style_link && !Object.keys(data.style_link).includes(selected_style_link)) {
        // Protection if style is not existing (issue with old files)
        set_selected_style_link('default');
    }
    const content = react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_grid' },
        react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menustylepanel_row_droplist' },
            react_1.default.createElement(react_2.Button, { variant: 'menuconfigpanel_add_button', onClick: () => {
                    const new_style = (0, SankeyUtils_1.DefaultLinkStyle)();
                    new_style.name = 'New Style';
                    const new_id = 'style_link_' + String(new Date().getTime());
                    new_style.idLink = new_id;
                    data.style_link[new_id] = new_style;
                    setForceUpdate(!forceUpdate);
                    updateComponentMenuConfigLink.current();
                    set_selected_style_link(new_style.idLink);
                    ref_input_name.current.value = data.style_link[new_id].name;
                } },
                react_1.default.createElement(fa_1.FaPlus, null)),
            react_1.default.createElement(react_2.Menu, null,
                react_1.default.createElement(react_2.MenuButton, { as: react_2.Button, variant: 'menuconfigpanel_option_button', rightIcon: react_1.default.createElement(fa_1.FaChevronDown, null) }, (selected_style_link !== '') ?
                    (0, SankeyUtils_1.CutName)(data.style_link[selected_style_link].name, 30) :
                    'Choix Style'),
                react_1.default.createElement(react_2.MenuList, null, Object
                    .keys(data.style_link)
                    .map((d, i) => react_1.default.createElement(react_2.MenuItem, { key: i, onClick: () => {
                        ref_input_name.current.value = data.style_link[d].name;
                        set_selected_style_link(d);
                    } }, data.style_link[d].name)))),
            react_1.default.createElement(react_2.Button, { variant: 'menuconfigpanel_del_button', isDisabled: (selected_style_link === 'default'), onClick: () => {
                    Object.values(data.links).filter(l => l.style == selected_style_link).forEach(l => l.style = 'default');
                    delete data.style_link[selected_style_link];
                    set_selected_style_link('default');
                    ref_selected_style_link.current = 'default';
                    setForceUpdate(!forceUpdate);
                    updateComponentMenuConfigLink.current();
                    link_function.RedrawLinks(Object.values(dict_variable_application_data.display_links));
                } },
                react_1.default.createElement(fa_1.FaMinus, null))),
        react_1.default.createElement(react_2.Box, { as: 'span', layerStyle: 'menuconfigpanel_row_2cols', gridTemplateColumns: '1fr 7fr' },
            react_1.default.createElement(react_2.Box, { layerStyle: 'menuconfigpanel_option_name', textStyle: 'h3' }, t('Menu.ns')),
            react_1.default.createElement(react_2.Box, null,
                react_1.default.createElement(react_2.InputGroup, { variant: 'menuconfigpanel_option_input' },
                    react_1.default.createElement(react_2.Input, { ref: ref_input_name, variant: 'menuconfigpanel_option_input', disabled: (selected_style_link === 'default') ? true : false, defaultValue: (selected_style_link !== '') ? data.style_link[selected_style_link].name : '', onBlur: () => {
                            var _a, _b;
                            data.style_link[selected_style_link].name = (_b = (_a = ref_input_name.current) === null || _a === void 0 ? void 0 : _a.value) !== null && _b !== void 0 ? _b : '';
                            setForceUpdate(!forceUpdate);
                            updateComponentMenuConfigLink.current();
                        } })))),
        (0, SankeyMenuConfigurationLinksAppearence_1.MenuConfigurationLinksAppearence)(dict_variable_application_data, dict_variable_elements_selected, applicationContext, additional_link_appearence_items, true, link_function, ComponentUpdater));
    return (0, SankeyMenuTop_1.MenuDraggable)(dict_hook_ref_setter_show_dialog_components, 'ref_setter_show_style_link', content, pointer_pos, t('Menu.esf'));
};
exports.SankeyModalStyleLink = SankeyModalStyleLink;
